import { render, staticRenderFns } from "./PaperClip.vue?vue&type=template&id=160c381d"
import script from "./PaperClip.vue?vue&type=script&lang=js"
export * from "./PaperClip.vue?vue&type=script&lang=js"
import style0 from "./PaperClip.vue?vue&type=style&index=0&id=160c381d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports